<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <index-table id="organization-deleted-index-table" endpoint="organizationsIndexDeleted" title="Organizations" icon="">
                <template slot="head">
                    <index-table-head slug="name">Name</index-table-head>
                    <index-table-head slug="reseller">Reseller</index-table-head>
                    <index-table-head slug="compliance_active" class="text-center">Compliance active</index-table-head>
                    <index-table-head slug="dfs_active" class="text-center">DFS active</index-table-head>
                    <index-table-head slug="academy_active" class="text-center">Academy active</index-table-head>
                    <index-table-head slug="deletedAt">Deleted at</index-table-head>
                    <index-table-head slug="actions" :sortable="false" class="text-center"></index-table-head>
                </template>
                <md-table-row class="search">
                    <index-table-filter-text slug="name"></index-table-filter-text>
                    <index-table-filter-text slug="reseller"></index-table-filter-text>
                    <index-table-filter-bool slug="compliance_active"></index-table-filter-bool>
                    <index-table-filter-bool slug="dfs_active"></index-table-filter-bool>
                    <index-table-filter-bool slug="academy_active"></index-table-filter-bool>
                    <index-table-filter-date slug="deletedAt"></index-table-filter-date>
                    <md-table-cell></md-table-cell>
                </md-table-row>
                <organization-deleted-row v-for="(item, key) in items" :key="key" :item="item"/>
            </index-table>
        </div>
    </div>
</template>

<script>

    import {mapGetters, mapMutations} from "vuex";
    import IndexTable from "../../../components/Index/IndexTable";
    import IndexTableHead from "../../../components/Index/IndexTableHead";
    import IndexTableFilterText from "@/new/components/Index/IndexTableFilterText";
    import IndexTableFilterBool from "@/new/components/Index/IndexTableFilterBool";
    import IndexTableFilterDate from "@/new/components/Index/IndexTableFilterDate";
    import OrganizationDeletedRow from "./OrganizationDeletedRow";

    export default {
        name: "OrganizationDeleted",
        components: {OrganizationDeletedRow, IndexTableHead, IndexTable, IndexTableFilterText, IndexTableFilterBool, IndexTableFilterDate},
        computed: {
            ...mapGetters('indexTable', {
                items: 'getItems',
            }),
        },
        methods: {
            ...mapMutations('app', {
                setTitlePage: 'setTitlePage',
            })
        },
        mounted() {
            this.setTitlePage(this.$t('Organizations'));
        }
    }
</script>

<style scoped>

</style>